import React from 'react';
import { createRoot } from 'react-dom/client';
import App from '../src/main-component/App/App';
import reportWebVitals from './reportWebVitals';
import './css/flaticon.css';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </React.StrictMode>
);

// Function to send Web Vitals metrics to Google Analytics
const sendToAnalytics = ({ id, name, value, delta }) => {
  if (window.gtag) {
    window.gtag('event', name, { // Use metric name as the event action
      event_category: 'Web Vitals',
      // Google Analytics metrics must be integers, so use delta rounding.
      // CLS is multiplied by 1000 for better granularity (standard practice).
      value: Math.round(name === 'CLS' ? delta * 1000 : delta),
      // The metric ID is unique to the current page load. When sending
      // multiple values from the same page load, pass the same ID.
      event_label: id,
      // Send metric values using the nonInteraction option for accurate bounce rate.
      non_interaction: true,
    });
  } else {
    // Fallback or logging if gtag is not available
    console.log('gtag not available, skipping Web Vitals analytics send for:', name);
  }
};

// Pass the analytics function to reportWebVitals
reportWebVitals(sendToAnalytics);
